import { Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import React from "react";

const delayRanges = [
  "Pago em dia",
  "5 a 15 dias",
  "16 a 30 dias",
  "31 a 60 dias",
  "61 a 90 dias",
  "91 a 180 dias",
  "Acima de 180 dias",
];

const ComportamentalPJ = ({ data }) => {
  const rawData =
    data?.PaymentsHistory?.PaymentHistory[0]?.PaymentHistory
      ?.PaymentHistoryConsulted[0]?.DelayPaymentHistory
      ?.DelayPaymentHistoryDetails || [];

  // Agrupamento e transformação no formato necessário
  const tableData = React.useMemo(() => {
    const grouped = {};

    rawData.forEach((item) => {
      const month = item.MonthYear;
      const delay = item.DelayRangePaidInstallments;
      const value = `${item.PaidInstallmentsAmount}\n${item.PercentagePaidInstallmentsAmount}`;
      if (!month) return;

      if (!grouped[month]) {
        grouped[month] = {
          MonthYear: month,
          ...Object.fromEntries(delayRanges.map((r) => [r, "R$ 0,00\n0%"])),
          "Total Mês": item.TotalPaidInstallmentsAmount,
        };
      }

      grouped[month][delay] = value;
      grouped[month]["Total Mês"] = item.TotalPaidInstallmentsAmount;
    });

    return Object.values(grouped);
  }, [rawData]);

  if (tableData.length === 0) return null;

  return (
    <>
      <TitleStripe>Comportamental</TitleStripe>

      <div className="title-syncx mt-4">
        Relacionamento de Negócios - Quantidade de instituições por tempo de
        relacionamento
      </div>
      {data?.BusinessRelationships?.BusinessRelationship[0]
        ?.RelationshipTimeRange?.RelationshipTimeRangesConsulted[0]
        ?.RelationshipTimeRange?.RelationshipTimeRangeDetails?.length > 0 && (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Tempo
              </td>
              {data?.BusinessRelationships?.BusinessRelationship[0]?.RelationshipTimeRange?.RelationshipTimeRangesConsulted[0]?.RelationshipTimeRange?.RelationshipTimeRangeDetails?.map(
                (item, index) => (
                  <td
                    key={index}
                    className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center"
                  >
                    {item.RelationshipTime}
                  </td>
                )
              )}
            </Table.Head>
            <Table.Body>
              <tr className="bg-gray-100">
                <td className="p-1"></td>
                {data?.BusinessRelationships?.BusinessRelationship[0]?.RelationshipTimeRange?.RelationshipTimeRangesConsulted[0]?.RelationshipTimeRange?.RelationshipTimeRangeDetails?.map(
                  (item, index) => (
                    <td
                      key={index}
                      className=" py-1 px-1 font-semibold text-xs  text-center"
                    >
                      {item.CountIf}
                    </td>
                  )
                )}
              </tr>
            </Table.Body>
          </Table>
        </div>
      )}

      <div className="flex gap-10 text-xs ">
        <div>
          <b>Filiais consultadas:</b>{" "}
          {data?.BusinessRelationships?.BusinessRelationship[0]
            ?.BranchesConsulted || "Sem informação"}
        </div>
        <div>
          <b>Quantidade Total de Ifs:</b>{" "}
          {
            data?.BusinessRelationships?.BusinessRelationship[0]
              ?.RelationshipTimeRange?.RelationshipTimeRangesConsulted[0]
              ?.TotalIFs
          }
        </div>
      </div>

      <div className="title-syncx mt-4">
        Endividamento - Compromissos assumidos considerando vencimento final dos
        contratos
      </div>
      {data?.InstallmentAndConsortiums?.InstallmentAndConsortium[0]
        ?.InstallmentConsortium?.InstallmentConsortiumConsulted[0]
        ?.ContracstEndTimeRange?.ContracstEndTimeRangeDetails?.length > 0 && (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Vencimento Final
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Quantidade
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Valor Contratado
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                % Saldo Devedor
              </td>
            </Table.Head>
            <Table.Body>
              {data?.InstallmentAndConsortiums?.InstallmentAndConsortium[0]?.InstallmentConsortium?.InstallmentConsortiumConsulted[0]?.ContracstEndTimeRange?.ContracstEndTimeRangeDetails?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{debit.ContractEndTimeRange}</td>
                    <td className="p-1 text-center">{debit.CountContracts}</td>
                    <td className="p-1 text-center">
                      {debit.TotalAmountContract}
                    </td>
                    <td className="p-1 text-center">
                      {debit.PercentageOutstandingBalance}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      )}

      <div className="flex gap-10 text-xs ">
        <div>
          <b>Filiais consultadas:</b>{" "}
          {data?.InstallmentAndConsortiums?.InstallmentAndConsortium[0]
            ?.BranchesConsulted || "Sem informação"}
        </div>
        <div>
          <b>Fontes consultadas:</b>{" "}
          {
            data?.InstallmentAndConsortiums?.InstallmentAndConsortium[0]
              ?.InstallmentConsortium?.InstallmentConsortiumConsulted[0]
              ?.TotalContract
          }
        </div>
      </div>

      <div className="title-syncx mt-4">
        Linhas de Crédito - Contratos ativos
      </div>

      {data?.Liabilities?.Liability[0]?.Liabilities?.LiabilitiesConsulted[0]
        ?.LabelsAndValue?.LabelsAndValuesDetails?.length > 0 && (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              {data?.Liabilities?.Liability[0]?.Liabilities?.LiabilitiesConsulted[0]?.LabelsAndValue?.LabelsAndValuesDetails?.map(
                (item, index) => (
                  <td
                    key={index}
                    className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center"
                  >
                    {item.ContractTypeLabels}
                  </td>
                )
              )}
            </Table.Head>
            <Table.Body>
              <tr className="bg-gray-100">
                {data?.Liabilities?.Liability[0]?.Liabilities?.LiabilitiesConsulted[0]?.LabelsAndValue?.LabelsAndValuesDetails?.map(
                  (item, index) => (
                    <td
                      key={index}
                      className=" py-1 px-1 font-semibold text-xs  text-center"
                    >
                      {item.OutstandingBalance}
                    </td>
                  )
                )}
              </tr>
            </Table.Body>
          </Table>
        </div>
      )}
      <div className="flex gap-10 text-xs ">
        <div>
          <b>Filiais consultadas:</b>{" "}
          {data?.Liabilities?.Liability[0]?.BranchesConsulted ||
            "Sem informação"}
        </div>
        <div>
          <b>Quantidade de contratos ativos:</b>{" "}
          {
            data?.Liabilities?.Liability[0]?.Liabilities
              ?.LiabilitiesConsulted[0]?.TotalContract
          }
        </div>
      </div>

      <div className="title-syncx mt-4">
        Pontualidade de pagamento - Operações Liquidadas nos últimos 12 meses
      </div>

      {data?.PunctualityOfPayments?.PunctualityOfPayment[0]
        ?.PunctualityOfPayment?.PunctualityOfPaymentConsulted[0]?.Installments
        ?.InstallmentsDetails?.length > 0 && (
        <div className="overflow-hidden rounded-md">
          <div className="border border-gray-200 rounded-md flex">
            <div
              className="flex-1 bg-gray-100 text-xs"
              style={{ minWidth: "180px" }}
            >
              <div className="border border-gray-200 p-2">Prazo</div>
              <div className="border border-gray-200 p-2">Qtd. Operações</div>
              <div className="border border-gray-200 p-2">%</div>
              <div className="border border-gray-200 p-2">Valor Total Op.</div>
            </div>

            {data?.PunctualityOfPayments?.PunctualityOfPayment[0]?.PunctualityOfPayment?.PunctualityOfPaymentConsulted[0]?.Installments?.InstallmentsDetails?.map(
              (item, index) => (
                <>
                  <div className="flex-1 text-xs" key={index}>
                    <div className="border border-gray-200 p-2 bg-gray-100">
                      {item.DelayRangePaidInstallments}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.CountPaidInstallments}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.PercentagePaidInstallments}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.PercentagePaidInstallmentsAmount}
                    </div>
                  </div>
                </>
              )
            )}
          </div>
        </div>
      )}
      <div className="flex gap-10 text-xs ">
        <div>
          <b>Filiais consultadas:</b>{" "}
          {data?.PunctualityOfPayments?.PunctualityOfPayment[0]
            ?.BranchesConsulted || "Sem informação"}
        </div>
      </div>

      <div className="title-syncx mt-4">
        Pontualidade de pagamento - Operações Liquidadas nos últimos 12 meses
      </div>

      {tableData?.length > 0 && (
        <div className="overflow-hidden rounded-md mt-2">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Mês/Ano
              </td>
              {delayRanges.map((range) => (
                <td
                  key={range}
                  className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white"
                >
                  {range}
                </td>
              ))}
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Total Mês
              </td>
            </Table.Head>
            <Table.Body className="text-xs">
              {tableData.map((row, index) => (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                >
                  <td className="p-1">{row.MonthYear}</td>
                  {delayRanges.map((range) => (
                    <td key={range} className="p-1 text-center">
                      {(row[range] || "R$ 0,00\n0%")
                        .split("\n")
                        .map((line, i) => (
                          <div key={i}>{line}</div>
                        ))}
                    </td>
                  ))}
                  <td className="p-1 text-center">{row["Total Mês"]}</td>
                </tr>
              ))}
            </Table.Body>
          </Table>
        </div>
      )}

      <div className="title-syncx mt-4">
        Histórico Operações Vencidas e Não Pagas nos últimos 24 Meses
      </div>

      {data?.OverdueAndUnPaidTwoYears?.OverdueAndUnPaidTwoYears[0]
        ?.OverdueAndUnPaidTwoYears?.OverdueAndUnPaidTwoYearsConsulted[0]
        ?.DelayOverdueAndUnPaid?.DelayOverdueAndUnPaidDetails?.length > 0 && (
        <div className="overflow-hidden rounded-md">
          <div className="border border-gray-200 rounded-md flex">
            <div
              className="flex-1 bg-gray-100 text-xs"
              style={{ minWidth: "230px" }}
            >
              <div className="border border-gray-200 p-2">Prazo</div>
              <div className="border border-gray-200 p-2">
                Qtd. parcela não paga
              </div>
              <div className="border border-gray-200 p-2">% não paga</div>
              <div className="border border-gray-200 p-2">
                Valor da parcela não paga
              </div>
              <div className="border border-gray-200 p-2">
                % do valor parcela não paga
              </div>
            </div>

            {data?.OverdueAndUnPaidTwoYears?.OverdueAndUnPaidTwoYears[0]?.OverdueAndUnPaidTwoYears?.OverdueAndUnPaidTwoYearsConsulted[0]?.DelayOverdueAndUnPaid?.DelayOverdueAndUnPaidDetails?.map(
              (item, index) => (
                <>
                  <div className="flex-1 text-xs" key={index}>
                    <div className="border border-gray-200 p-2 bg-gray-100">
                      {item.DelayRangeUnpaidInstallments}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.CountUnpaidInstallments}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.PercentageUnpaidInstallmentsAmount}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.UnpaidInstallmentsAmount}
                    </div>
                    <div className="border border-gray-200 p-2">
                      {item.PercentageUnpaidInstallments}
                    </div>
                  </div>
                </>
              )
            )}
          </div>
        </div>
      )}
      <div className="flex gap-10 text-xs ">
        <div>
          <b>Filiais consultadas:</b>{" "}
          {data?.OverdueAndUnPaidTwoYears?.OverdueAndUnPaidTwoYears[0]
            ?.BranchesConsulted || "Sem informação"}
        </div>
      </div>

      <div className="title-syncx mt-4">
        Análise Setorial (considera empresas do mesmo setor de atividade e
        porte)
      </div>

      <div className="border border-gray-100 rounded-md text-sm">
        <div className="px-2 border-gray-100 border py-2">
          Código da Atividade Principal:{" "}
          {data?.SectorAnalysis?.SectorAnalysis[0]?.MainActivity}
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          Descrição Atividade Principal:{" "}
          {data?.SectorAnalysis?.SectorAnalysis[0]?.MainActivityDescription}
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Porte Empresa: {data?.SectorAnalysis?.SectorAnalysis[0]?.CompanyPort}
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-primary text-white font-semibold">
          Pontualidade de pagamento do Setor - Valores em Reais (12 meses)
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Valor total Médio Operações liquidadas Pontualmente:{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]
              ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
              ?.AnalysisPunctualityOfPayment
              ?.AnalysisPunctualityOfPaymentConsulted[0]?.PaidInstallmentsAmount
          }
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          Percentual médio de operações liquidadas pontualmente(a):{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]
              ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
              ?.AnalysisPunctualityOfPayment
              ?.AnalysisPunctualityOfPaymentConsulted[0]
              ?.PercentagePaidInstallmentsAmount
          }
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Quantidade média de operações liquidadas pontualmente:{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]
              ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
              ?.AnalysisPunctualityOfPayment
              ?.AnalysisPunctualityOfPaymentConsulted[0]?.CountPaidInstallments
          }
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          Percentual de quantidade médio de operações liquidadas
          pontualmente(b):{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]
              ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
              ?.AnalysisPunctualityOfPayment
              ?.AnalysisPunctualityOfPaymentConsulted[0]
              ?.PercentagePaidInstallments
          }
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Média de pontualidade geral(a+b/2):{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]
              ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
              ?.AnalysisPunctualityOfPayment
              ?.AnalysisPunctualityOfPaymentConsulted[0]?.AveragePunctuality
          }
        </div>
        {data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisPunctualityOfPayment
          ?.PunctualityOfPayment[0]?.AnalysisSectorPunctuality
          ?.AnalysisSectorPunctuality[0]?.CNPJPunctualityRanking && (
          <div className="px-2 border-gray-100 border py-2 bg-gray-100">
            {
              data?.SectorAnalysis?.SectorAnalysis[0]
                ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
                ?.AnalysisSectorPunctuality?.AnalysisSectorPunctuality[0]
                ?.CNPJPunctualityRanking
            }
          </div>
        )}

        {data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisPunctualityOfPayment
          ?.PunctualityOfPayment[0]?.AnalysisSectorPunctuality
          ?.AnalysisSectorPunctuality[0]?.CNPJvsPaidInstallmentsSector && (
          <div className="px-2 border-gray-100 border py-2">
            {
              data?.SectorAnalysis?.SectorAnalysis[0]
                ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
                ?.AnalysisSectorPunctuality?.AnalysisSectorPunctuality[0]
                ?.CNPJvsPaidInstallmentsSector
            }
          </div>
        )}
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          {
            data?.SectorAnalysis?.SectorAnalysis[0]
              ?.AnalysisPunctualityOfPayment?.PunctualityOfPayment[0]
              ?.BranchesConsulted
          }
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-primary text-white font-semibold">
          Operações em Aberto do Setor - Valores em Reais (12 meses)
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Valor médio de operações vencidas:{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisOverdueAndUnPaid
              ?.AnalysisOverdueAndUnPaidConsulted[0]?.UnpaidInstallmentsAmount
          }
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          Percentual médio de operações vencidas(a):{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisOverdueAndUnPaid
              ?.AnalysisOverdueAndUnPaidConsulted[0]
              ?.PercentageUnpaidInstallmentsAmount
          }
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Quantidade média de operações vencidas:{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisOverdueAndUnPaid
              ?.AnalysisOverdueAndUnPaidConsulted[0]?.CountUnpaidInstallments
          }
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          Percentual médio de quantidade de operações vencidas(b):{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisOverdueAndUnPaid
              ?.AnalysisOverdueAndUnPaidConsulted[0]
              ?.PercentageUnpaidInstallments
          }
        </div>
        <div className="px-2 border-gray-100 border py-2">
          Média de operações vencidas(a+b/2):{" "}
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisOverdueAndUnPaid
              ?.AnalysisOverdueAndUnPaidConsulted[0]?.AveragUnpaidTransactions
          }
        </div>
        <div className="px-2 border-gray-100 border py-2  bg-gray-100">
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisSectorUnpaidTransactions
              ?.AnalysisSectorUnpaidTransaction[0]
              ?.CNPJvsUnPaidInstallmentsSector
          }
        </div>
        <div className="px-2 border-gray-100 border py-2">
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.AnalysisSectorUnpaidTransactions
              ?.AnalysisSectorUnpaidTransaction[0]?.RankingUnpaidTransactions
          }
        </div>
        <div className="px-2 border-gray-100 border py-2 bg-gray-100">
          {
            data?.SectorAnalysis?.SectorAnalysis[0]?.AnalysisOverdueAndUnPaid
              ?.OverdueAndUnPaidOutput[0]?.BranchesConsulted
          }
        </div>
      </div>
    </>
  );
};

export default ComportamentalPJ;
